<template>
    <div class="d-flex align-center">
        <div class="pt-3 mr-n2">
            <hb-text-field
                condensed
                box
                medium
                v-model="accessCode"
                placeholder="Enter Code"
                id="gate code"
                name="gate code"
                :error="error"
            >
            </hb-text-field>
        </div>
        <hb-btn 
            icon 
            @click="generateCode" 
            tooltip="Generate Code" 
            active-state-off 
            :disabled="disableGeneration || generatingCode"
        >
            mdi-refresh
        </hb-btn>
    </div>


</template>


<script type="text/babel">

import { notificationMixin } from  '../../mixins/notificationMixin.js';
import api from '../../assets/api.js';

export default{
        name: "AccessCodeSelector",
        mixins: [ notificationMixin ],
        data(){
            return {
                generatingCode: false
            }
        },
        props: {
            value:{
                type: String,
                default: ""
            },
            disableGeneration:{
                type: Boolean,
                default: false
            },
            areaId:{
                type: String,
                required: true
            },
            propertyId:{
                type: String,
                required: true
            },
            generateOnMounted:{
                type: Boolean,
                default: true
            },
            error:{
                type: Boolean,
                default: false
            }
        },
        mounted(){
            if (this.generateOnMounted) this.generateCode();
        },
        destroyed() {
            this.$emit('input', "");
        },
        computed:{
            accessCode: {
                get () {
                    return this.value;
                },
                set (value) {
                    this.$emit('input', value);
                }
            },
            canGenerateCode() {
                return !!(this.propertyId && this.areaId)
            }
        },
        methods:{
            async generateCode(){
                if (!this.generatingCode) {
                    this.generatingCode = true;
                    try {
                        let r = await api.get(this, api.PROPERTIES + this.propertyId + '/areas/' + this.areaId + '/generate-access-code');
                        this.accessCode = r.code;
                    } catch(err){
                        this.accessCode = ""
                    } finally {
                        this.generatingCode = false;
                    }
                }
            },
            async validateCode() {
                const codeValidated = await this.$validator.validateAll('code');
                this.$emit('update:codeValidated', codeValidated)
            }
            
        },
        watch:{
            canGenerateCode(value) {
                if (value && !this.accessCode && this.generateOnMounted) this.generateCode();
            }
        }
}


</script>
